/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A header row like x,y,size documents the columns.`)
};

const es_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una fila de cabecera como x,y,tamaño documenta las columnas.`)
};

const de_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Kopfzeile wie x,y,size dokumentiert die Spalten.`)
};

const nl_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een headerrij zoals x,y,grootte documenteert de kolommen.`)
};

const fr_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une ligne d'en-tête comme x,y,taille documente les colonnes.`)
};

const it_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una riga di intestazione come x,y,dimensione documenta le colonne.`)
};

const pt_br2_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho como x,y,tamanho documenta as colunas.`)
};

const pt_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho como x,y,tamanho documenta as colunas.`)
};

const ja_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,y,sizeのようなヘッダー行は列の内容を示します。`)
};

const zh_bubble_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如 x,y,size 这样的表头行用于说明各列含义。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_ex3", locale)
	if (locale === "en") return en_bubble_ex3(inputs)
	if (locale === "es") return es_bubble_ex3(inputs)
	if (locale === "de") return de_bubble_ex3(inputs)
	if (locale === "nl") return nl_bubble_ex3(inputs)
	if (locale === "fr") return fr_bubble_ex3(inputs)
	if (locale === "it") return it_bubble_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_ex3(inputs)
	if (locale === "pt") return pt_bubble_ex3(inputs)
	if (locale === "ja") return ja_bubble_ex3(inputs)
	return zh_bubble_ex3(inputs)
};